export const sampleLoan = {
  id: '5c5e0b2aa5bd3900133151bf',
  RTDocumentId: 557687594,
  adjustable: false,
  amount: 265000,
  amountForMerge: 165000,
  archiveUuid: 'a21cf6a7-35ac-4b81-90ca-5dfe4cee8ee2',
  created: '2019-02-08T23:05:14.000Z',
  date: '2015-09-01',
  documentType: 'Warranty Deed',
  homeId: '585d76f13f59ed00049abe72',
  lender: 'PRIVATE INDIVIDUAL',
  loanType: 'FIRST CEL',
  rate: 4.625,
  refi: false,
  source: 'user',
  status: 'current',
  termYearsEstimated: 30,
  termYears: 30,
  payment: {
    total: 1362.47,
    principal: 397.85691978098555,
    interest: 964.6130802190145
  },
  facts: {
    monthlyPayment: 1362.47,
    totalInterest: 225488.98040903936
  },
  progress: {
    interestLeft: 184747.57894767064,
    interestPaid: 40741.40146136872,
    interestDiff: 0,
    paymentsLeft: 319,
    paymentsMade: 41,
    principalLeft: 249880.13146136873,
    principalPaid: 15119.868538631285,
    principalDiff: 0
  },
  maturityDate: {
    nochange: {
      date: '2045-09-01',
      interestPid: 225488.98040903936,
      monthsLeft: 319
    }
  },
  stats: {
    interestSavings: {
      nochange: 0
    },
    totalCost: {
      nochange: 490488.98040903936
    }
  },
  cashout: {
    amount: null,
    ownershipPercent: null,
    percent: null,
    retainPercent: 20
  },
  refiToday: {
    fix30Yr: {
      amount: 249880.13146136873,
      APR: 4.676376,
      date: '2019-01-31T00:00:00.000Z',
      fee: 1499.2807887682125,
      interest: {
        diff: -27877.03051718595,
        total: 212624.6094648566
      },
      payment: {
        total: 1284.73,
        principal: 375.15352764692375,
        interest: 909.5764723530763,
        diff: 77.74000000000001
      },
      points: 0.6,
      periods: 360,
      principal: {
        diff: 15121.80946485643,
        total: 249878.19053514357
      },
      rate: 4.625
    },
    fix15Yr: {
      amount: 249880.13146136873,
      APR: 4.213623,
      date: '2019-01-31T00:00:00.000Z',
      fee: 1499.2807887682125,
      interest: {
        diff: 99102.92430573261,
        total: 85644.65464193803
      },
      payment: {
        total: 1864.02,
        principal: 1152.9322920182117,
        interest: 711.0877079817884,
        diff: -501.54999999999995
      },
      points: 0.6,
      periods: 180,
      principal: {
        diff: 15121.05464193804,
        total: 249878.94535806196
      },
      rate: 4.125
    },
    fix25Yr: {
      amount: 249880.13146136873,
      APR: 4.683998,
      date: '2019-01-31T00:00:00.000Z',
      fee: 1499.2807887682125,
      interest: {
        diff: 12615.805325294263,
        total: 172131.77362237638
      },
      payment: {
        total: 1406.7,
        principal: 517.411974085754,
        interest: 889.2880259142461,
        diff: -44.23000000000002
      },
      points: 0.6,
      periods: 300,
      principal: {
        diff: 15121.773622376175,
        total: 249878.22637762383
      },
      rate: 4.625
    },
    fix20Yr: {
      amount: 249880.13146136873,
      APR: 4.444962,
      date: '2019-01-31T00:00:00.000Z',
      fee: 1499.2807887682125,
      interest: {
        diff: 59253.98768539885,
        total: 125493.59126227179
      },
      payment: {
        total: 1564.05,
        principal: 755.3560259745711,
        interest: 808.6939740254288,
        diff: -201.57999999999993
      },
      points: 0.6,
      periods: 240,
      principal: {
        diff: 15121.591262271657,
        total: 249878.40873772834
      },
      rate: 4.375
    },
    CUSTOM: {
      amount: 249880.13146136873,
      APR: 4.681458,
      date: '2019-01-31T00:00:00.000Z',
      fee: 1499.2807887682125,
      interest: {
        diff: 5.820766091346741e-11,
        total: 184747.57894767058
      },
      payment: {
        total: 1362.47,
        principal: 465.8247716098217,
        interest: 896.6452283901783,
        diff: 0
      },
      points: 0.6,
      periods: 319,
      principal: {
        diff: 15119.648947670561,
        total: 249880.35105232944
      },
      rate: 4.625
    }
  }
}
